module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingKassaimobilen.f7ee42a1.png";